import type { AppConfig } from '../types'
import type { Action, BookingState } from '../booking/state'
import { track } from '../analytics'
import { Icon } from '../icons'

/** 7.2 Choose a visit type (sub-profile) — only reached when the profile has them. */
export function SubProfileStep({
  config,
  state,
  dispatch,
  onBack,
  embedded
}: {
  config: AppConfig
  state: BookingState
  dispatch: React.Dispatch<Action>
  onBack: () => void
  embedded?: boolean
}) {
  // In-person options always list before virtual/telehealth, whatever the
  // config order (stable sort keeps ties in authored order).
  const subs = [...(state.profile?.sub_profiles ?? [])].sort(
    (a, b) => Number(!!a.is_telemed) - Number(!!b.is_telemed)
  )
  const heading = config.copy?.subProfileHeading || 'How would you like to be seen?'

  return (
    <section>
      <h1 className="step-heading">{heading}</h1>
      <p className="step-sub">{state.profile?.name}</p>

      <div className="card-grid">
        {subs.map((sp, i) => (
          <button
            key={`${sp.id}-${i}`}
            className="choice-card"
            onClick={() => {
              track('select_sub_profile', { sub_profile: sp.id, name: sp.name })
              dispatch({ type: 'SELECT_SUB_PROFILE', subProfile: sp })
            }}
          >
            <span className="icon-tile" aria-hidden>
              <Icon value={sp.is_telemed ? 'chat' : 'doctor'} size={26} />
            </span>
            <span className="title">{sp.name}</span>
            {sp.description ? (
              <span className="desc">{sp.description}</span>
            ) : sp.is_telemed ? (
              <span className="desc">Virtual / telehealth visit</span>
            ) : null}
          </button>
        ))}
      </div>

      {!embedded && (
        <div className="btn-row">
          <button className="btn btn-ghost" onClick={onBack}>
            ← Back
          </button>
        </div>
      )}
    </section>
  )
}
